export const hideDataConfig = [
  '0x84fa8fe46a41151396beeabc9167a114c06e1f882d827c4a7f5ab8676de63e14',
];
